import { Stack } from 'expo-router';

import GoBackButton from '@/components/buttons/GoBackButton';
import PlatformContainer from '@/components/web/PlatformContainer';

export default function StackLayout() {
  return (
    <PlatformContainer contentCustomClassnames="flex">
      <Stack>
        <Stack.Screen
          name="index"
          options={{
            headerTransparent: true,
            headerTitle: '',
            headerLeft: () => <GoBackButton navigateTo={'/'} />,
            headerShown: true,
            headerBackVisible: false
          }}
        />
        <Stack.Screen
          name="verifyCode"
          options={{
            headerTransparent: true,
            headerTitle: '',
            headerLeft: () => <GoBackButton />,
            headerShown: true,
            headerBackVisible: false
          }}
        />
        <Stack.Screen
          name="profile"
          options={{
            headerShown: false
          }}
        />
        <Stack.Screen
          name="distances"
          options={{
            headerShown: false
          }}
        />
        <Stack.Screen
          name="interests"
          options={{
            headerShown: false
          }}
        />
        <Stack.Screen
          name="eula"
          options={{
            headerShown: false
          }}
        />
      </Stack>
    </PlatformContainer>
  );
}
